/** 埋点事件名称枚举 */
export enum ActivityWhatsAppEventNameEnum {
  /** 点击来自步骤 - 确定错误 */
  CLICK_SENDER_CONFIRM_ERROR = 'click_sender_confirm_error',
  /** 点击来自步骤 - 确定 */
  CLICK_SENDER_CONFIRM = 'click_sender_confirm',
  /** 点击发送时间步骤 - 确定错误 */
  CLICK_SCHEDULE_CONFIRM_ERROR = 'click_schedule_confirm_error',
  /** 点击发送时间步骤 - 确定 */
  CLICK_SCHEDULE_CONFIRM = 'click_schedule_confirm',
  /** 点击模板步骤 - 确定错误 */
  CLICK_TEMPLATE_CONFIRM_ERROR = 'click_template_confirm_error',
  /** 点击模板步骤 - 确定 */
  CLICK_TEMPLATE_CONFIRM = 'click_template_confirm',
  /** 点击目标联系人步骤 - 确定错误 */
  CLICK_RECIPIENTS_CONFIRM_ERROR = 'click_recipients_confirm_error',
  /** 点击目标联系人步骤 - 确定 */
  CLICK_RECIPIENTS_CONFIRM = 'click_recipients_confirm',
  /** 点击保存并退出 */
  CLICK_SAVE_AND_EXIT = 'click_save_and_exit',
  /** 点击发布 */
  CLICK_PUBLISH = 'click_publish',
  /** 点击活动名称 - 编辑 */
  CLICK_ACTIVITY_NAME_EDIT = 'click_activity_name_edit',
  /** 点击活动名称 - 确定 */
  CLICK_ACTIVITY_NAME_CONFIRM = 'click_activity_name_confirm',
  /** 草稿提交错误 */
  DRAFT_SUBMIT_ERROR = 'draft_submit_error',
  /** 草稿提交成功 */
  DRAFT_SUBMIT_SUCCESS = 'draft_submit_success',
  /** 活动发布错误 */
  PUBLISH_ERROR = 'publish_error',
  /** 活动发布成功 */
  PUBLISH_SUCCESS = 'publish_success',
  /** 删除活动错误 */
  DELETE_ACTIVITY_ERROR = 'delete_activity_error',
  /** 删除活动成功 */
  DELETE_ACTIVITY_SUCCESS = 'delete_activity_success',
  /** 活动名称校验 - 重复 */
  ACTIVITY_NAME_VALIDATION_DUPLICATE = 'activity_name_validation_duplicate',
  /** 活动名称校验 - 通过 */
  ACTIVITY_NAME_VALIDATION_SUCCESS = 'activity_name_validation_success',
  /** 活动名称校验 - 错误 */
  ACTIVITY_NAME_VALIDATION_ERROR = 'activity_name_validation_error',
}
